import { Flex, LinkV2, StyleSystemProps, styled } from '@withjoy/joykit';

export const FooterPrivacyMenuWrapper = styled(Flex)``;
const footerPrivacyMenuWrapperStyles: StyleSystemProps = {
  columnGap: 6,
  rowGap: 6,
  flexDirection: ['column', null, null, 'row']
};

export const StyledLinkV2 = styled(LinkV2)`
  text-decoration: none;
  color: white;
  &:visited {
    color: white;
  }
  &:hover {
    color: ${props => props.theme.colors.mono5};
  }
  &:active {
    color: white;
  }
`;

export const NoreferrerLinkV2 = styled(StyledLinkV2)<{ noreferrer?: boolean; noopener?: boolean }>``;

export const styles = {
  footerPrivacyMenuWrapper: footerPrivacyMenuWrapperStyles
};
